import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Container from '../layouts/Container';
import { useProjects } from '../context/ProjectContext';

const NewProject = () => {
  const [project, setProject] = useState('');
  const { addProject } = useProjects();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newProject = await addProject(project);
    setProject("");
    if (newProject) {
      navigate(`/projects/${newProject.id}/regions`);
    }
  };

  return (
    <Container>
      <h1>Add New Project</h1>
      <Form onSubmit={handleSubmit} className="d-flex gap-2">
        <Form.Control
          type="text"
          placeholder="Enter something..."
          value={project}
          required
          onChange={(e) => setProject(e.target.value)}
        />
        <Button type="submit" variant="primary">
          Submit
        </Button>
      </Form>
    </Container>
  );
};

export default NewProject;
